import React, { useEffect } from "react";
import editorialImg from "../assets/WebImage/editorial.jpg";

function Editorial() {
  const today = new Date();

  useEffect(() => {
    document.title = "Free Credit - Editorial Policy";
  }, []);

  return (
    <>
      <div className="card m-2">
        <div style={{ textAlign: "justify" }}>
          {" "}
          <div>
            <img
              style={{ maxWidth: "100%", height: "auto", display: "block" }}
              loading="lazy"
              src={editorialImg}
              alt="Editorial-Jom Free Credit Malaysia"
            />
          </div>
          <div className="p-3">
            <h1>Editorial Policy & Guidelines</h1>
            <strong>Published On: </strong>1 April 2026
            <br />
            <strong>Last Updated: </strong>
            {today.toLocaleDateString("en-MY", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
            <br />
            <br />
            <p>
              At JomFreeCredit.online, we are committed to maintaining a high
              standard of editorial integrity, accuracy, and transparency in all
              published content.
            </p>
            <p>
              This Editorial Policy outlines the principles, processes, and
              standards that guide how we research, evaluate, and present
              information related to online casino platforms and free credit
              promotions.
            </p>
            <p>
              Our goal is to provide Malaysian users with reliable, unbiased,
              and clearly structured information to support informed
              decision-making.
            </p>
            <p>
              We operate strictly as an independent informational and affiliate
              platform. We do not operate gaming services, manage user accounts,
              or handle financial transactions.
            </p>
            <hr />
            <h2>Editorial Principles</h2>
            <p>
              All content published on our platform is guided by the following
              principles:
            </p>
            <ul>
              <li>
                <strong>Accuracy:</strong> Information is verified to the best
                of our knowledge at the time of publication
              </li>
              <li>
                <strong>Transparency:</strong> Promotional terms and conditions
                are clearly explained
              </li>
              <li>
                <strong>Independence:</strong> Editorial decisions are not
                influenced by commercial partnerships
              </li>
              <li>
                <strong>Clarity:</strong> Content is written in a structured and
                easy-to-understand manner
              </li>
              <li>
                <strong>User Protection:</strong> We prioritize responsible
                presentation of gaming-related information
              </li>
            </ul>
            <hr />
            <h2>Content Review Process</h2>
            <p>
              Our editorial team follows a structured review process before
              publishing any platform or promotion:
            </p>
            <ul>
              <li>Verification of platform information and accessibility</li>
              <li>Review of promotional terms and conditions</li>
              <li>Assessment of claim and withdrawal procedures</li>
              <li>Evaluation of user experience and interface</li>
              <li>Monitoring of publicly available user feedback</li>
            </ul>
            <p>
              Where applicable, test accounts may be created for validation
              purposes.
            </p>
            <hr />
            <h2>Evaluation Framework</h2>
            <p>
              Platforms featured on JomFreeCredit.online are assessed using a
              standardized evaluation framework to ensure consistency and
              fairness.
            </p>
            <hr />
            <h2 style={{ textAlign: "left" }}>
              1. Licensing & Operational Transparency
            </h2>
            <p>We assess whether a platform demonstrates:</p>
            <ul>
              <li>Disclosure of licensing or regulatory information</li>
              <li>Use of secure technologies (e.g., HTTPS encryption)</li>
              <li>Availability of clear terms and conditions</li>
              <li>Transparency in ownership or operational details</li>
            </ul>
            <p>
              While regulatory standards may vary across jurisdictions,
              platforms that demonstrate higher levels of transparency are
              prioritized.
            </p>
            <hr className="mx-auto" style={{ width: "100px" }} />
            <h2 style={{ textAlign: "left" }}>
              Assessment & Weighting Approach
            </h2>
            <p>
              Each platform is evaluated across multiple criteria within our
              framework. Certain factors may carry greater importance depending
              on user relevance and risk considerations.
            </p>
            <ul>
              <li>Promotional transparency</li>
              <li>Operational credibility</li>
              <li>Withdrawal clarity</li>
              <li>User experience</li>
              <li>Mobile compatibility</li>
            </ul>
            <p>
              Evaluations are qualitative in nature and may be updated as
              platform conditions change.
            </p>
            <hr className="mx-auto" style={{ width: "100px" }} />
            <h2>Ongoing Review & Monitoring</h2>
            <p>
              Our editorial responsibility extends beyond initial publication.
            </p>
            <p>We continuously monitor:</p>
            <ul>
              <li>Changes in promotional terms</li>
              <li>User feedback trends</li>
              <li>Platform performance and accessibility</li>
            </ul>
            <p>
              If a platform no longer meets our editorial standards, we may:
            </p>
            <ul>
              <li>Update or revise content</li>
              <li>Adjust evaluation summaries</li>
              <li>Remove listings where necessary</li>
            </ul>
            <hr className="mx-auto" style={{ width: "100px" }} />
            <h2>Responsible Use Disclaimer</h2>
            <p>
              We encourage users to review all promotional terms carefully and
              make informed decisions.
            </p>
            <p>
              Online gaming should be treated as a form of entertainment and not
              as a guaranteed source of income.
            </p>
            <hr className="mx-auto" style={{ width: "100px" }} />
            <h2 style={{ textAlign: "left" }}>
              Editorial Independence & Disclosure
            </h2>
            <p>
              JomFreeCredit.online may receive affiliate commissions from
              certain partner platforms.
            </p>
            <p>
              However, such partnerships do not influence our editorial
              evaluations, rankings, or inclusion criteria.
            </p>
            <p>
              All platforms must meet our internal standards before being
              published.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Editorial;
